/**
 * Banner variants
 * @enum {string}
 * @readonly
 */
export const BANNER_VARIANT = {
  header: 'header',
  banner: 'banner',
  medium: 'medium',
  small: 'small',
};
